<influencer-module-container [title]="'INFLUENCER.insight.follower_growth.title' | translate"
    [tooltip]="'INFLUENCER.insight.follower_growth.tooltip' | translate"
    [hasNoData]="hasNoData"
    [isFetchingData]="isFetchingData"
    [placeholderWidth]="301"
    [printMode]="printMode"
    [height]="printMode ? '282px' : '335px'">

    <div class="chart-area" [class.print-mode]="printMode">
        <achoo-line-chart *ngIf="!hasNoData && !isFetchingData" [chartData]="data"
            [legendEnabled]="false"
            [xAxisDateTimeLabelFormat]="'%m/%y'"
            [useDefaultPlaceholder]="false"
            [spacingBottom]="printMode ? 10 : null"
            [smYAxisFontSize]="printMode ? null : '1rem'"
            [areaFillColor]="areaFillColor"
            [axisFontFamily]="axisFontFamily"
            [yAxisValueMode]="'thousand'"
            [yAxisMax]="yAxisMax"
            [overridenTooltipConfig]="overridenTooltipConfig">
        </achoo-line-chart>

        <achoo-line-chart *ngIf="hasNoData || isFetchingData" [chartData]="placeholderData"
            [legendEnabled]="false"
            [xAxisDateTimeLabelFormat]="'%m/%y'"
            [useDefaultPlaceholder]="false"
            [spacingBottom]="printMode ? 10 : null"
            [smYAxisFontSize]="printMode ? null : '1rem'"
            [areaFillColor]="areaFillColor"
            [axisFontFamily]="axisFontFamily"
            [yAxisValueMode]="'thousand'">
        </achoo-line-chart>
    </div>

</influencer-module-container>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/follower-growth/follower-growth.component.html